import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { WithAnnotationText } from '@/components/ui/Typography/Body/WithAnnotationText/WithAnnotationText';
import { RFP_NEGOTIATE_TYPE_BUDGET, RFP_NEGOTIATE_TYPE_START_DATE, RFP_NEGOTIATE_TYPE_END_DATE, } from '@/utils/constants/rfp/rfpNegotiate/type';
export const RfpMessageListNoDate = (props) => {
    const { className = '', isNegotiableBudget, isNegotiableEndDate, isNegotiableStartDate, } = props;
    const NegotiableText = useMemo(() => {
        const list = [
            isNegotiableBudget ? RFP_NEGOTIATE_TYPE_BUDGET.label : '',
            isNegotiableStartDate ? RFP_NEGOTIATE_TYPE_START_DATE.label : '',
            isNegotiableEndDate ? RFP_NEGOTIATE_TYPE_END_DATE.label : '',
        ].filter((item) => !!item);
        // MEMO: 仕様的に 0件の場合はない想定
        return list.length > 0 ? `${list.join('と')}です。` : 'ありません。';
    }, [isNegotiableBudget, isNegotiableStartDate, isNegotiableEndDate]);
    return (_jsxs(Text, Object.assign({ className: clsx('text-center', className), color: 'base', size: 'sm' }, { children: ["\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u6761\u4EF6\u306B\u95A2\u3059\u308B\u76F8\u8AC7\u306F\u307E\u3060\u5C4A\u3044\u3066\u3044\u307E\u305B\u3093\u3002", _jsx(WithAnnotationText, Object.assign({ isBold: false, size: 'none' }, { children: `このプロジェクトで相談可能な条件は、${NegotiableText}` }))] })));
};
